export const truncate = (word: string, max: number, suffix = '.'): string => {
  if (word.length < max) {
    return word;
  }
  return word.substring(0, max - 1) + suffix;
};
